import React, { Component } from 'react';
import Counter from '../common/Counter';
import { observer } from 'mobx-react';
import { createGlobalStyle } from 'styled-components';
import { withTranslation } from 'react-i18next';
import { Box, Button, Grid, Modal } from '@mui/material';

@observer
class ToppingCounterModal extends Component {
  state = {
    qty: 1,
  };

  // 최대 수량
  get maxQty() {
    const { toppingGroup, topping } = this.props;

    if (!toppingGroup || !topping) return 0;

    // 토핑 그룹 최대 개수가 0이면 토핑 아이템 최대 개수 반환
    if (toppingGroup.maxCount === 0) return topping.maxCount;

    // 그룹 남은 수량 계산
    const groupRemainingCount =
      toppingGroup.maxCount -
      toppingGroup.toppings.filter(t => t.isChecked).reduce((acc, topping) => acc + topping.qty, 0);

    // 그룹 남은 수량과 토핑 최대 수량 중 더 작은 값 반환
    if (topping.maxCount === 0) {
      return groupRemainingCount;
    } else {
      return Math.min(groupRemainingCount, topping.maxCount);
    }
  }

  // 토핑 총 추가 금액
  get totalAddPrice() {
    return Number(this.props.topping.addPrice) * Number(this.state.qty);
  }

  /** 모달이 열릴 때 수량 초기화 */
  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ qty: 1 });
    }
  }

  handleCountChange = qty => {
    this.setState({ qty });
  };

  handleConfirm = () => {
    this.props.onConfirm(this.state.qty);
  };

  render() {
    const { t, isOpen, toppingGroup, topping, onClose } = this.props;
    if (!toppingGroup || !topping) return null; // 모달이 닫혀있으면 렌더링 X

    return (
      <>
        <GlobalStyle />
        <Modal open={isOpen} className="modal-container">
          <section>
            <header>
              <div className="topping-group-name">{toppingGroup.name}</div>
              <Box className="topping-group-desc" bgcolor="secondary.main">
                {t('menu.label.optionMaxCount', { n: this.maxQty })}
              </Box>
            </header>
            <main>
              <div className="topping-name">
                {topping.name} {topping.addPrice > 0 && <span>(+{topping.addPrice})</span>}{' '}
              </div>
              <div className="topping-counter">
                <Counter count={this.state.qty} max={this.maxQty} onCountChange={this.handleCountChange} />
              </div>
            </main>
            <footer>
              <Grid item style={{ minWidth: '80px' }}>
                <Button fullWidth color="secondary" size="large" variant="outlined" onClick={onClose}>
                  {t('common.button.cancel')}
                </Button>
              </Grid>
              <Grid item xs>
                <Button fullWidth color="primary" size="large" variant="contained" onClick={this.handleConfirm}>
                  {this.totalAddPrice > 0 && <span style={{ marginRight: '10px' }}>+{this.totalAddPrice}</span>}
                  {t('common.button.confirm')}
                </Button>
              </Grid>
            </footer>
          </section>
        </Modal>
      </>
    );
  }
}

const GlobalStyle = createGlobalStyle`
  .modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 500px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .topping-group-name {
        font-size: 18px;
        font-weight: bold;
      }

      .topping-group-desc {
        padding: 5px 10px;
        color: #fff;
        border-radius: 4px;
      }
    }

    main {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
    }

    footer {
      display: flex;
      flex-direction: row;
      gap: 10px;
    }
  }
`;

export default withTranslation()(ToppingCounterModal);
